import { useReducer } from 'react'
import { paymentStateReducer } from './reducer'
import { PaymentState } from './types'

export const useServerPaymentReducer = (
  paymentIntentId?: string,
  isRecovery?: boolean
) => {
  const initialState: PaymentState = isRecovery
    ? {
        status: 'recovering',
        paymentIntentId,
      }
    : { status: 'creatingTransaction' }
  return useReducer(paymentStateReducer, initialState)
}
